import React from 'react';
import SignupErr from "./SignupErr";
import InfoBubble from '../components/InfoBubble';
import infoTexts from '../components/infoTexts';

const SignupQuestions = ({ err, apartment, prevStep, nextStep, setStep, handleChange, values, focusedTitleRef }) => {
    const Continue = e => {
        e.preventDefault();
        nextStep();
    }

    const Previous = e => {
        e.preventDefault();
        prevStep();
    }

    const Back = e => {
        e.preventDefault();
        setStep(0);
    }

    return (
        <section>
			<div className="article-categories">
				<a href={`/wohnung/?id=${apartment.apartmentId}`} className="article-category">{apartment.title}</a>
			</div>
			<h1 ref={focusedTitleRef} tabIndex="-1"><span>Info-Formular</span></h1>

			<SignupErr err={ err } />

			<div className="row gy-5">
				<div className="col-12">
					<label
						htmlFor={'reason'}
						className="form-label"
					>
						Wieso suchen Sie eine neue Wohnung?
					</label>
					<textarea
						id={'reason'}
						onChange={handleChange('reason')}
						defaultValue={values.reason}
						rows={6}
						className="form-control"
					>
					</textarea>
				</div>

				<div className="col-6">
					<label className="form-label">
						Wohnen Sie bereits bei der GWG?
					</label>
					<div className="form-check">
						<input
							type="radio"
							value="yes"
							checked={values.gwgMember === "yes"}
							onChange={handleChange('gwgMember')}
							className="form-check-input"
							id="gwgMemberYes"
						/>
						<label className="form-check-label" htmlFor="gwgMemberYes">Ja</label>
					</div>
					<div className="form-check">
						<input
							type="radio"
							value="no"
							checked={values.gwgMember === "no"}
							onChange={handleChange('gwgMember')}
							className="form-check-input"
							id="gwgMemberNo"
						/>
						<label className="form-check-label" htmlFor="gwgMemberNo">Nein</label>
					</div>
				</div>
				<div className="col-6">
					{/* The info button must not be inside the label, otherwise clicking the label text would toggle it */}
					<div className="form-label">
						<label className="d-inline">Wie viele Personen sollen in der Wohnung leben?</label>
						<InfoBubble label="Mindestbelegung" text={ infoTexts.mindestbelegung } />
					</div>
					<select
						onChange={handleChange('peopleCount')}
						defaultValue={values.peopleCount}
						className="form-select"
					>
						<option>1</option>
						<option>2</option>
						<option>3</option>
						<option>4</option>
						<option>5</option>
						<option>6</option>
						<option>7</option>
						<option>8</option>
						<option>9</option>
						<option>10</option>
					</select>
				</div>
				<div className="col-6">
					<label className="form-label">
						Monatliches Haushaltseinkommen
					</label>
					<p>Eine Faustregel besagt, dass die Monatsmiete nicht mehr als 30% des Bruttoeinkommens Ihres Haushalts sein sollte. Liegt Ihr Bruttohaushaltseinkommen über <b>Fr. { Math.ceil((apartment.meta.rentPerMonth / 30 * 100).toFixed() / 50)*50 }.- im Monat</b>?</p>
					<div className="form-check">
						<input
							type="radio"
							value="yes"
							checked={values.recommendedIncome === "yes"}
							onChange={handleChange('recommendedIncome')}
							className="form-check-input"
							id="recommendedIncomeYes"
						/>
						<label className="form-check-label" htmlFor="recommendedIncomeYes">Ja</label>
					</div>
					<div className="form-check">
						<input
							type="radio"
							value="no"
							checked={values.recommendedIncome === "no"}
							onChange={handleChange('recommendedIncome')}
							className="form-check-input"
							id="recommendedIncomeNo"
						/>
						<label className="form-check-label" htmlFor="recommendedIncomeNo">Nein</label>
					</div>
				</div>
				<div className="col-6">
					<label className="form-label">Haben Sie Katzen?</label>
					<div className="form-check">
						<input
							type="radio"
							value="no"
							checked={values.hasCats === "no"}
							onChange={handleChange('hasCats')}
							className="form-check-input"
							id="hasCatsNo"
						/>
						<label className="form-check-label" htmlFor="hasCatsNo">Nein</label>
					</div>
					<div className="form-check">
						<input
							type="radio"
							value="indoors"
							checked={values.hasCats === "indoors"}
							onChange={handleChange('hasCats')}
							className="form-check-input"
							id="hasCatsYes"
						/>
						<label className="form-check-label" htmlFor="hasCatsYes">Ja, nur zu Hause</label>
					</div>
					<div className="form-check">
						<input
							type="radio"
							value="outdoors"
							checked={values.hasCats === "outdoors"}
							onChange={handleChange('hasCats')}
							className="form-check-input"
							id="hasCatsYesOutdoor"
						/>
						<label className="form-check-label" htmlFor="hasCatsYesOutdoor">Ja, die Katzen brauchen Auslaufmöglichkeiten</label>
					</div>
				</div>

				<div className="col-12">
					<label
						htmlFor={'comment'}
						className="form-label"
					>
						Möchten Sie uns noch etwas mitteilen?
					</label>

					<textarea
						id={'comment'}
						onChange={handleChange('comment')}
						defaultValue={values.comment}
						rows={6}
						className="form-control"
					>
					</textarea>
				</div>
			</div>
			<div className="d-flex justify-content-between mt-5 flex-row-reverse">
				<button onClick={ Continue } className="btn btn-secondary">Weiter</button>
				<button onClick={ Previous } className="btn btn-secondary btn-back">Zurück</button>
			</div>
        </section>
    )
}

export default SignupQuestions
